import React from 'react'
import PropTypes from 'prop-types'

import Col from 'component/utils/Col'
import Modal from 'component/utils/Modal'

const ViewModal = ({ closeModal, handleUpdate, record, translate }) => {
  const renderItem = (label, value) => (
    <div className='pricebanner-config-view-container'>
      <p className='pricebanner-config-view-label'>{translate(label)}</p>
      {value}
    </div>
  )

  const renderRangeTable = () => (
    <table>
      <thead>
        <tr>
          <th>{translate('config.pricebannerConfig.view.ranges')}</th>
          <th>{translate('config.pricebannerConfig.form.cdParcelLabel')}</th>
          <th>{translate('config.pricebannerConfig.tableHeader.dsDynamic')}</th>
          <th>{translate('config.pricebannerConfig.view.valueLimit')}</th>
        </tr>
      </thead>
      <tbody>{record.parcelRangeList.map(renderParcelRange)}</tbody>
    </table>
  )

  const renderParcelRange = (parcelRange, i) => (
    <tr key={parcelRange.cdParcelRange}>
      <td>{`${translate('config.pricebannerConfig.view.range')} ${i + 1}`}</td>
      <td>{getDsParcel(parcelRange.cdParcel, parcelRange.dsParcel)}</td>
      <td>{parcelRange.dsNewDynamic}</td>
      <td>{parcelRange.dsValue}</td>
    </tr>
  )
  const getDsParcel = (cd, ds) =>
    cd > 1 ? ds : `${ds} ${translate('config.pricebannerConfig.view.noParcel')}`

  return (
    <Modal size='md' closeModal={closeModal}>
      <h2 className='pricebanner-config-modal-title'>
        <strong>{translate('config.pricebannerConfig.viewTitle')}</strong>
      </h2>
      {renderItem(
        'config.pricebannerConfig.tableHeader.dsDynamic',
        record.dsDynamic
      )}
      {renderItem('config.pricebannerConfig.tableHeader.dsCard', record.dsCard)}
      {renderItem(
        'config.pricebannerConfig.view.parcelRange',
        renderRangeTable()
      )}
      {renderItem(
        'config.pricebannerConfig.form.dtPeriodLabel',
        record.dsPeriod
      )}
      <Col xsOffset={4} xs={4} className='margin-top-double'>
        <button
          onClick={handleUpdate}
          type='button'
          className='button button-dark-mini full'
        >
          {translate('edit_button_label')}
        </button>
      </Col>
    </Modal>
  )
}

ViewModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

export default ViewModal
